import { render, staticRenderFns } from "./ExamIndex.vue?vue&type=template&id=3f209358&scoped=true&"
import script from "./ExamIndex.vue?vue&type=script&lang=js&"
export * from "./ExamIndex.vue?vue&type=script&lang=js&"
import style0 from "./ExamIndex.vue?vue&type=style&index=0&id=3f209358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f209358",
  null
  
)

export default component.exports